"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var HTTP = 'http';
var PROTOCOL_HTTPS = 'https:';
var getTheoplayerURLBase = function getTheoplayerURLBase(browserProtocol, version) {
  // In electron apps, the default protocol is file:// so
  // we need to force it to use https. In a browser, we can
  // just use whatever protocol was on the page.
  var moduleBaseProtocol = browserProtocol.includes(HTTP) ? browserProtocol : PROTOCOL_HTTPS;
  return "".concat(moduleBaseProtocol, "//static.hudl.com/theoplayer/").concat(version, "/");
};
var _default = exports["default"] = getTheoplayerURLBase;